import { render, staticRenderFns } from "./CONGRESSO_PIBJCU.vue?vue&type=template&id=69c8eff6&scoped=true"
import script from "./CONGRESSO_PIBJCU.vue?vue&type=script&lang=js"
export * from "./CONGRESSO_PIBJCU.vue?vue&type=script&lang=js"
import style0 from "./CONGRESSO_PIBJCU.vue?vue&type=style&index=0&id=69c8eff6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c8eff6",
  null
  
)

export default component.exports